const ModelValueMixin = function (value_type, propname = 'modelValue') {
  const evupdate = `update:${propname}`
  const evchange = propname == 'modelValue' ? 'change' : `change:${propname}`
  const valuename = propname == 'modelValue' ? 'value' : propname

  let defval = undefined
  switch (value_type) {
    case Boolean: defval = false; break
    case String: defval = ''; break
    case Number: defval = 0; break
    case Array: defval = () => []; break
    case Object: defval = () => ({}); break
    case Date: new Date(); break
  }

  const props = {}
  props[propname] = {type: value_type, default: defval}

  const computed = {}
  computed[valuename] = {
    set(value) {
      this.$emit(evupdate, value)
      this.$emit(evchange, this)
    },
    get() {
      return this[propname]
    }
  }

  return {
    props: props,
    emits: [evupdate, evchange],
    computed: computed
  }
}

export default ModelValueMixin